import { ofType } from "redux-observable";
import { mapTo, take } from "rxjs/operators";
import { TypeActionTutorial } from "../../../tutorial/actionTutorial";
import { actionGameTrackingUpdateFps } from "../../actionGameTracking";
import { IdGameTrackingFpsEventName } from "../IdGameTrackingFpsEventName";
export var epicGameTrackingFpsMemoryUsageTutorialFirstButtonClick = function (action$, state$) {
    return action$.pipe(ofType(TypeActionTutorial.HarvestClickAcre), take(1), mapTo(actionGameTrackingUpdateFps(IdGameTrackingFpsEventName.FIRST_TUTORIAL_BUTTON_CLICKED)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/epics/epicGameTrackingFpsMemoryUsageTutorialFirstButtonClick.ts
// module id = 1865
// module chunks = 3